import * as React from "react";

import "./Icon.css";

const SvgWarehouseIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 47.96 47.96"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(0,2)">
      <path d="M24 0 0 12.83v28.35h3.76V17.23h40.48v23.95H48V12.83z" />
      <path d="M5.24 30.34h11.03v10.94H5.24zM17.81 30.34h11.03v10.94H17.81zM5.24 18.46h11.03V29.4H5.24z" />{" "}
    </g>
  </svg>
);
export default SvgWarehouseIcon;
